import ActionTypes from "../actions/types";

export default function(state = "", action) {
	switch (action.type) {
		case ActionTypes.SELECT_EXPIRATION:
			return action.payload;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/selectedExpirationReducer.js